export default __webpack_public_path__ + "static/media/disable-comments-icon-256x256.c2b183bb.png";